export default {

    metaData: (state) => {
        return state.meta;
      },
      transactionsList: (state) => {
        return state.transactions;
      },
}
